"use strict";
window.theme = window.theme || {}
theme.OptimumAllAssets = function() {
    function OptimumAllAssets() {
        this.assets = {
            scripts: theme.optimized_script,
            render: true
        }
        this.load();
        
    }
    OptimumAllAssets.prototype.load = function() {
            var _ = this;                       
        window.addEventListener('mousemove', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                let seeking_slide_position = setInterval(() => {
                    let slide_show_slides = document.querySelectorAll('.slideshow__cell.render-optimum');
                    if(slide_show_slides.length > 0) {
                        slide_show_slides.forEach(slide => {
                            if(slide.style.visibility = 'visible') {
                                slide.style.removeProperty('visibility')
                                clearInterval(seeking_slide_position);
                            }
                        })
                    }              
                })
                let seeking_slide_visibility = setInterval(() => {
                    let slide_show_render_id = document.getElementById('slideshow-render-id');
                    let slideshow_slides = document.querySelectorAll('.slideshow__slides.flickity-enabled.is-draggable');
                    if(slideshow_slides.length > 0) {
                        if(slide_show_render_id)slide_show_render_id.style.removeProperty('margin-top');
                        clearInterval(seeking_slide_visibility);
                    }              
                })
                seeking_slide_position;
                seeking_slide_visibility;              
                _.assets.render = false;
            }           
        })
        window.addEventListener('scroll', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                let seeking_slide_position = setInterval(() => {
                    let slide_show_slides = document.querySelectorAll('.slideshow__cell.render-optimum');
                    if(slide_show_slides.length > 0) {
                        slide_show_slides.forEach(slide => {
                            if(slide.style.visibility = 'visible') {
                                slide.style.removeProperty('visibility')
                                clearInterval(seeking_slide_position);
                            }
                        })
                    }              
                })
                let seeking_slide_visibility = setInterval(() => {
                    let slide_show_render_id = document.getElementById('slideshow-render-id');
                    let slideshow_slides = document.querySelectorAll('.slideshow__slides.flickity-enabled.is-draggable');
                    if(slideshow_slides.length > 0) {
                        if(slide_show_render_id)slide_show_render_id.style.removeProperty('margin-top');
                        clearInterval(seeking_slide_visibility);
                    }              
                })
                seeking_slide_position;
                seeking_slide_visibility;                
                _.assets.render = false;
            }           
        })
        window.addEventListener('touchstart', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                let seeking_slide_position = setInterval(() => {
                    let slide_show_slides = document.querySelectorAll('.slideshow__cell.render-optimum');
                    if(slide_show_slides.length > 0) {
                        slide_show_slides.forEach(slide => {
                            if(slide.style.visibility = 'visible') {
                                slide.style.removeProperty('visibility')
                                clearInterval(seeking_slide_position);
                            }
                        })
                    }              
                })
                let seeking_slide_visibility = setInterval(() => {
                    let slide_show_render_id = document.getElementById('slideshow-render-id');
                    let slideshow_slides = document.querySelectorAll('.slideshow__slides.flickity-enabled.is-draggable');
                    if(slideshow_slides.length > 0) {
                        if(slide_show_render_id)slide_show_render_id.style.removeProperty('margin-top');
                        clearInterval(seeking_slide_visibility);
                    }              
                })
                seeking_slide_position;
                seeking_slide_visibility;                   
                _.assets.render = false;
            }           
        })
        window.addEventListener('click', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                let seeking_slide_position = setInterval(() => {
                    let slide_show_slides = document.querySelectorAll('.slideshow__cell.render-optimum');
                    if(slide_show_slides.length > 0) {
                        slide_show_slides.forEach(slide => {
                            if(slide.style.visibility = 'visible') {
                                slide.style.removeProperty('visibility')
                                clearInterval(seeking_slide_position);
                            }
                        })
                    }              
                })
                let seeking_slide_visibility = setInterval(() => {
                    let slide_show_render_id = document.getElementById('slideshow-render-id');
                    let slideshow_slides = document.querySelectorAll('.slideshow__slides.flickity-enabled.is-draggable');
                    if(slideshow_slides.length > 0) {
                        if(slide_show_render_id)slide_show_render_id.style.removeProperty('margin-top');
                        clearInterval(seeking_slide_visibility);
                    }              
                })
                seeking_slide_position;
                seeking_slide_visibility;              
                _.assets.render = false;
            }           
        })
        window.addEventListener('resize', event => {
            if(_.assets.scripts.length > 0 && _.assets.render) {
                _.assets.scripts.forEach(src => {
                    var newscript = document.createElement('script');
                    newscript.src = src;
                    document.head.appendChild(newscript);
                });               
                let seeking_slide_position = setInterval(() => {
                    let slide_show_slides = document.querySelectorAll('.slideshow__cell.render-optimum');
                    if(slide_show_slides.length > 0) {
                        slide_show_slides.forEach(slide => {
                            if(slide.style.visibility = 'visible') {
                                slide.style.removeProperty('visibility')
                                clearInterval(seeking_slide_position);
                            }
                        })
                    }              
                })
                let seeking_slide_visibility = setInterval(() => {
                    let slide_show_render_id = document.getElementById('slideshow-render-id');
                    let slideshow_slides = document.querySelectorAll('.slideshow__slides.flickity-enabled.is-draggable');
                    if(slideshow_slides.length > 0) {
                        if(slide_show_render_id)slide_show_render_id.style.removeProperty('margin-top');
                        clearInterval(seeking_slide_visibility);
                    }              
                })
                seeking_slide_position;
                seeking_slide_visibility;              
                _.assets.render = false;
            }           
        })
      
    }

    theme.OptimumAllAssets = new OptimumAllAssets;
}

theme.OptimumAllAssets();
